import {
  TimeSettingsEnumsTimeTypeEnum,
  TimeSettingsSplitCustomTimeRangeCategoriesDocument,
  TimeSettingsSplitCustomTimeRangeCategory,
} from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

export const useSplitTimeSettingsCustomTimeRangeCategories = (companyId: number) => {
  const { data, loading } = useQuery(TimeSettingsSplitCustomTimeRangeCategoriesDocument, {
    variables: { companyId, active: true },
    fetchPolicy: 'cache-first',
  })

  const rawCategories = data?.timeSettings?.splitCustomTimeRangeCategoriesConnection?.nodes ?? []

  const splitCustomTimeRangeCategories = rawCategories.map((rawCategory) => {
    return SplitCustomTimeRangeCategory.fromRaw(rawCategory)
  })

  return {
    loading,
    splitCustomTimeRangeCategories,
  }
}

export class SplitCustomTimeRangeCategory {
  id: number
  name: string
  timeType: TimeSettingsEnumsTimeTypeEnum
  companyId: number
  constructor(
    id: number,
    name: string,
    timeType: TimeSettingsEnumsTimeTypeEnum,
    companyId: number
  ) {
    this.id = id
    this.name = name
    this.timeType = timeType
    this.companyId = companyId
  }

  static fromRaw(rawCategory: TimeSettingsSplitCustomTimeRangeCategory) {
    return new SplitCustomTimeRangeCategory(
      rawCategory.id,
      rawCategory.name,
      rawCategory.timeType,
      rawCategory.companyId
    )
  }
}
